import React from "react";

export const TABS_UI_FRAME_CLASS =
  "inline-block border-2 border-green-100 text-center font-medium bg-white/5 backdrop-blur-lg py-1 px-2 rounded-xl shadow-md";
export const TABS_UI_WRAPPER_CLASS = "text-center mt-2";

export const TABS_UI_ITEM_BASE_CLASS =
  "text-xs lg:text-base text-gray-900 rounded-md border-2 cursor-pointer px-2 py-1 border-green-200 backdrop-blur-sm transition-all duration-300";

export const TABS_UI_ITEM_ACTIVE_CLASS =
  "border-pink-400 bg-purple-100/70 text-black font-bold shadow-2xl backdrop-blur-lg ring-2 ring-purple-300/50 rounded-xl p-3";

export function TabsUiFrame({ children, className = "" }) {
  return (
    <div className={TABS_UI_WRAPPER_CLASS}>
      <div className={`${TABS_UI_FRAME_CLASS} ${className}`.trim()}>{children}</div>
    </div>
  );
}

export function TabsUiItem({
  label,
  active = false,
  onClick,
  className = "",
  activeClassName = TABS_UI_ITEM_ACTIVE_CLASS,
}) {
  const classes = `${TABS_UI_ITEM_BASE_CLASS} ${active ? activeClassName : ""} ${className}`.trim();
  return (
    <div className={classes} onClick={onClick}>
      {label}
    </div>
  );
}
